export const MODULE_OPTIONS = [
  { code: 'originacion', label: 'Originación' },
  { code: 'core_bancario', label: 'Cálculos de contrato y pagos' },
  { code: 'pld_cumplimiento', label: 'Cumplimiento y PLD' },
  { code: 'bulk_load', label: 'Cargas Masivas de datos y facturación' },
  { code: 'reportes', label: 'Reportes' },
  { code: 'integraciones', label: 'Integraciones con terceros' }
]

export const PRIORITY_OPTIONS = [
  { code: 'baja', label: 'Baja' },
  { code: 'media', label: 'Media' },
  { code: 'alta', label: 'Alta' },
  { code: 'urgente', label: 'Urgente' }
]

export const TYPE_OPTIONS = [
  { code: 'problem', label: 'Problema' },
  { code: 'feature_request', label: 'Solicitud de función' },
  { code: 'question', label: 'Pregunta' }
]

export const STATUS_OPTIONS = [
  { code: 'nuevo', label: 'Nuevo' },
  { code: 'en_proceso', label: 'En Atención' },
  { code: 'on_hold', label: 'En espera' },
  { code: 'escalado', label: 'Escalado' },
  { code: 'dependencia_cliente', label: 'Dependencia con cliente' },
  { code: 'validacion_cliente', label: 'En espera de validación por cliente' },
  { code: 'cerrado', label: 'Cerrado' }
]
